import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '@kodit/core/data-api';

export interface SupportAccessRequestDto {
  id: number;
  requestedByEmail: string;
  requestedByName: string;
  requestedAt: string;
  status: string;
  expiresAt?: string;
  testUserEmail?: string;
}

@Injectable({ providedIn: 'root' })
export class SupportAccessRequestService {
  private _baseUrl: string;

  constructor(
    private _http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this._baseUrl = baseUrl ?? '';
  }

  getRequests(): Observable<any> {
    return this._http.get(`${this._baseUrl}/api/support-access-request`);
  }

  createRequest(targetTenantKey: string): Observable<any> {
    return this._http.post(`${this._baseUrl}/api/support/access-request`, { targetTenantKey });
  }

  approve(id: number): Observable<any> {
    return this._http.put(`${this._baseUrl}/api/support-access-request/${id}/approve`, {});
  }

  reject(id: number): Observable<any> {
    return this._http.put(`${this._baseUrl}/api/support-access-request/${id}/reject`, {});
  }
}
